import React, { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export const priceLabel = (p) =>
  `$${Number(p.price_amount).toLocaleString()}${p.price_unit === "hour" ? "/hr" : " flat"}`;

export const ProviderSelect = ({ type, value, onChange }) => {
  const [providers, setProviders] = useState([]);

  useEffect(() => {
    let stop = false;
    fetch(`${API}/api/services/providers?type=${type}`)
      .then((r) => r.json())
      .then((d) => { if (!stop) setProviders(d.providers || []); })
      .catch(() => {});
    return () => { stop = true; };
  }, [type]);

  if (providers.length === 0) return null;
  return (
    <label className="req-field">
      <span className="req-label">Book a member (optional)</span>
      <select
        className="req-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={`provider-select-${type}`}
      >
        <option value="">No preference — let the team assign</option>
        {providers.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name} — {priceLabel(p)}{p.booking_fee ? ` · $${p.booking_fee} booking fee` : ""}
          </option>
        ))}
      </select>
    </label>
  );
};
